export default {
  notFoundCargoType:
    "Sorry, the cargo schedule you selected is full or unavailable.",
  successCreateMessage:
    'Cargo shipment with number<br /><b>"{cargoNo}"</b> was created successfully.',
  successCreateMessageV2:
    'Cargo shipment with number<b> "{cargoNo}"</b><br />was created successfully.',
  partialCreateMessage:
    'Some STT numbers were scheduled successfully for cargo shipment<br />with number <b>"{cargoNo}"</b>. However, several STTs failed.<br />Please remove the problematic STTs to continue the cargo shipment.',
  confirmCreateCargoTitle: "Confirm Creation?",
  placeholderAdd: "Example: STT/Bagging no.: 99LP1234567890123/88-22-12345678",
  secondPlaceholderAdd: "Enter STT/Shipment/Bag no. ",
  confirmSubtitleEditCargo:
    "Please make sure all STT details are correct and complete.",
  titlePopupEditCargo: "Changes Saved!",
  subtitlePopupEditCargo:
    'Cargo shipment details with number<br/><b>"{cargoNo}"</b> were updated successfully.',
  subtitlePartialEditCargo:
    'Some STTs under cargo number <b>"{cargoNo}"</b><br />were updated successfully, but several STTs failed.<br />Please download the file to review the errors.',
  editDimensionInfo: "Edit if dimensions change",
  volumeWeightBag: "Bag volume weight",
  errorBagExceed: "Bag weight exceeds STT weight.",
  kotaAsal: "Console origin city",
  kotaTujuanBag: "Bag destination city",
  createdBy: "Created by",
  createdDate: "Created date",
  updatedBy: "Updated by",
  updatedDate: "Updated date",
  bagGrossWeight: "Bag gross weight",
  bagVolumeWeight: "Bag volume weight",
  createSuccessTitle: "Bagging Successfully Created!",
  createSuccessMessage: "Bagging has been successfully created.",
  createRtcSuccessTitle: "Ready to Cargo Bagging Successfully Created",
  createRtcSuccessMessage:
    "Bagging has been successfully created and will be updated in Ready to Cargo",
  createPartialMessage:
    "Some STT numbers were successfully bagged, but errors occurred on several STTs.<br />Please download to check the errors.",
  createFailedTitle: "Bagging Creation Failed!",
  createFailedMessage: "Failed to create bagging.",
  scanSttFailedTitle: "STT Scan Failed",
  addSttFailedTitle: "Add STT Number Failed",
  updateSuccessTitle: "Changes Successfully Saved!",
  updatePartialTitle: "Status Update Successful!",
  updatePartialMessage:
    "Some STT statuses were successfully updated to Bagging, but errors occurred on several STTs. Please download to check the errors.",
  updateFailedTitle: "Status Update Failed!",
  updateFailedMessage: "Failed to update Bagging status.",
  successAddSttNumber: "Successfully added STT number!",
  yes: "Yes",
  no: "No",
  scanFailedListTitle: "List of failed STT/Bag scans",
  excel: {
    title: "Failed STT scans",
    noStt: "STT/Bag Number",
    status: "Latest STT/Bag Status",
    reason: "Failure Reason"
  },
  tabs: {
    bookingSuccess: "Booked Successfully",
    bookingInProgressWithCount: "Booking In Progress({count})",
    bookingCanceled: "Canceled/Failed Booking",
    readyToCargoInProgress: "Ready to Cargo In Progress",
    readyToCargoList: "Ready to Cargo List"
  },
  actions: {
    bookingCargo: "Book Cargo",
    bookingNow: "Book now",
    createNewBooking: "New Booking",
    chooseSchedule: "Choose schedule",
    continue: "Continue",
    chooseCargo: "Choose cargo",
    add: "Add",
    edit: "Edit",
    save: "Save",
    back: "Back",
    cancel: "Cancel",
    cancelBooking: "Cancel",
    delete: "Delete",
    rebook: "Book Again",
    process: "Process",
    processCargo: "Process Cargo",
    bookAndPrintPdf: "Book & Print PDF",
    bookAndPrintLabel: "Book & Print Label",
    editCargo: "Edit Cargo",
    editAndPrintPdf: "Edit & Print PDF",
    editAndPrintLabel: "Edit & Print Label",
    printLabel: "Print label",
    printManifestCargo: "Print cargo manifest",
    printPti: "Print PTI",
    printSptj: "Print SPTJ",
    printCargoReceipt: "Print cargo receipt",
    printAwbLionCargo: "AWB Lion Cargo",
    downloadEpl: "Download EPL",
    download: "Download",
    downloadExcel: "Download Excel",
    yesDelete: "Yes, Delete",
    yesRebook: "Yes, Book Again",
    changeTransport: "Change Transport",
    saveTransport: "Save transport",
    otherTransport: "Other Transport",
    editPieces: "Edit Pieces",
    inspect: "Check",
    viewDetail: "View Detail",
    manualInput: "Fill Manually",
    checkAgain: "Check Again",
    reset: "Reset",
    apply: "Apply",
    changeSearch: "Change Search",
    reload: "Reload",
    leave: "Leave",
    stayHere: "Stay here",
    ok: "OK",
    yes: "Yes",
    no: "No"
  },
  labels: {
    cargo: "Cargo",
    cargoLowercase: "cargo",
    bookingNumber: "Booking No.",
    cargoNumber: "Cargo No.",
    cargoNumberSmu: "Cargo No./AWB",
    cargoNumberLowercase: "Cargo no.",
    flightNumber: "Flight No.",
    flightNumberLong: "Flight number",
    vehicleSerialNumber: "Vehicle Serial No.",
    vehicleSerialOrFlightNumber: "Vehicle serial no./</br>flight no.",
    cargoType: "Cargo Type",
    cargoTypeLowercase: "Cargo type",
    userType: "User Type",
    partnerName: "Partner Name",
    date: "Date",
    day: "day",
    noReference: "Reference No.",
    noReferenceLowercase: "Reference no.",
    noBag: "Bag No.",
    createdBy: "Created by",
    updatedBy: "Updated by",
    lastUpdated: "Last updated",
    consoleOriginCity: "Console origin city",
    bagDestinationCity: "Bag destination city",
    courier: "Courier",
    noStt: "STT No.",
    failedSttCount: "Failed STT No.",
    successSttCount: "Successful STT No.",
    noSttBagging: "STT/Bagging No.",
    noSttOrBagging: "STT/Bagging No.",
    commodity: "Commodity",
    cargoCommodity: "Cargo Commodity",
    cargoCommodityLowercase: "Cargo commodity",
    cargoCommodityGroup: "Cargo Commodity Group",
    cargoProduct: "Cargo Product",
    cargoProductLowercase: "Cargo product",
    cargoProductType: "Cargo product type",
    shipmentType: "Product type",
    product: "Product",
    natureOfGoodsNog: "Nature of Goods (NOG)",
    shipmentDetail: "Shipment Details",
    shipmentDetailLowercase: "Shipment details",
    cargoDetail: "Cargo Details",
    pieceDetail: "Piece Details",
    route: "Route",
    nog: "NOG",
    shc: "SHC",
    etdEta: "ETD/ETA",
    atdAta: "ATD/ATA",
    chargeableGrossVolumeKg: "Chargeable/Gross/Volume (kg)",
    cargoChargeableWeightShort: "Chargeable Bag",
    chargeableWeightCargo: "Cargo chargeable weight",
    chargeableWeightStt: "Chargeable weight (STT)",
    chargeableWeightReweigh: "Chargeable weight (Reweigh)",
    grossWeight: "Gross weight",
    grossWeightStt: "Gross weight (STT)",
    grossWeightSttShort: "STT gross weight",
    grossWeightReweigh: "Gross weight (Reweigh)",
    grossWeightCargo: "Cargo gross weight",
    totalGrossWeight: "Total Gross Weight",
    totalDimensionWeight: "Total Dimension Weight",
    totalCargoGrossWeightTitle: "Total Cargo Gross Weight",
    totalCargoGrossWeight: "Total cargo gross weight",
    totalActualCargoGrossWeight: "Actual cargo gross weight",
    totalActualCargoGrossWeightTitle: "Actual Cargo Gross Weight",
    totalActualGrossWeight: "Actual gross weight",
    totalActualCargoGrossWeightManifest: "Actual Cargo Gross Weight Total",
    actualTotalCargoGrossWeightLabel: "Actual Total Cargo Gross Weight",
    volumeWeight: "Volume weight",
    volumeWeightStt: "Volume weight (STT)",
    volumeWeightSttShort: "STT volume weight",
    volumeWeightReweigh: "Volume weight (Reweigh)",
    volumeWeightCargo: "Cargo volume weight",
    totalVolumeWeight: "Total Cargo Volume Weight",
    totalCargoVolumeWeight: "Total cargo volume weight",
    totalActualCargoVolumeWeight: "Actual cargo volume weight",
    totalActualCargoVolumeWeightTitle: "Actual Cargo Volume Weight",
    totalActualVolumeWeight: "Actual volume weight",
    totalActualCargoVolumeWeightManifest: "Actual Cargo Volume Weight Total",
    actualTotalCargoVolumeWeightLabel: "Actual Total Cargo Dimension Weight",
    totalEstimatedCargoGrossWeight: "Estimated Cargo Gross Weight Total",
    totalEstimatedCargoVolumeWeight: "Estimated Cargo Volume Weight Total",
    totalActualWeight: "Actual total weight",
    totalCargoWeight: "Total cargo weight",
    totalStt: "Total STT",
    totalSttPieces: "Total STT/pieces",
    pieces: "Pieces",
    totalPieces: "Total Pieces",
    totalPiecesLowercase: "Total pieces",
    totalActualPieces: "Actual total pieces",
    cargoPieces: "Cargo pieces",
    pieceNumber: "Piece No.",
    dimension: "Dimension",
    weightDimension: "Dimension & weight",
    cargoDimension: "Cargo dimension",
    packageDimension: "Dimension/package (L x W x H)",
    estimatedDepartureArrival: "Estimated departure/arrival",
    pieceValue: "Piece Value",
    createdAt: "Created at",
    updatedAt: "Updated at",
    departureDate: "Departure date",
    arrivalDate: "Arrival date",
    departureDateTitle: "Departure Date",
    arrivalDateTitle: "Arrival Date",
    departureTime: "Departure Time",
    arrivalTime: "Arrival Time",
    originCity: "Origin city",
    destinationCity: "Destination city",
    originAirport: "Origin airport",
    destinationAirport: "Destination airport",
    destinationAirportCode: "Destination airport code",
    originDestinationCities: "Origin - destination city",
    cargoStatus: "Cargo status",
    failedReason: "Failure reason",
    manage: "Manage",
    grossVolumeWeightKg: "Gross/volume weight (kg)",
    weightDifference: "Weight difference",
    bookingStartDate: "Booking start date",
    bookingEndDate: "Booking end date",
    hubLocation: "Hub Location",
    bookingUser: "Booking user",
    destinationSummary: "Destination City",
    commoditySummary: "Commodity",
    cargoChoice: "Cargo Options",
    cargoRecommendation: "Cargo Recommendation",
    client: "Client",
    weight: "Weight",
    totalWeight: "Total weight",
    totalVolume: "Total volume weight",
    direct: "Direct",
    totalTransit: "Total transit",
    transitAirport: "Transit airport {index}",
    pieceDimension: "Piece Dimension",
    estimatedDeparture: "Estimated departure",
    flyIn: "Fly In",
    routeFlight: "Flight route",
    planeScheduleNumber: "Plane Schedule {index}",
    duration: "Flight Duration",
    allFlights: "All flights",
    minimumWeightPerPieceSmu: "AWB with minimum weight per piece",
    action: "Action",
    transitCountBadge: "{count}x transit",
    totalBagWeightDifference: "Total Bags with Weight Difference",
    weightBagDifference: "Weight difference bag",
    bagWithWeightDifference: "Bag with weight difference",
    listSttBag: "List STT/bag"
  },
  placeholders: {
    selectCargoType: "Select Cargo Type",
    selectClient: "Select client",
    allClients: "All clients",
    selectDestinationCity: "Select destination city",
    selectCommodity: "Select commodity",
    selectProduct: "Select Product",
    selectTime: "Select time",
    selectHubLocation: "Select hub location",
    selectBookingUser: "Select booking user",
    selectStartDate: "Enter start date",
    selectEndDate: "Enter end date",
    selectOriginAirport: "Select origin airport",
    selectDestinationAirport: "Select destination airport",
    enterNog: "Enter NOG",
    enterShc: "Enter SHC",
    enterCargoNumber: "Enter cargo no.",
    enterVehicleSerialNumber: "Enter vehicle serial no.",
    enterFlightNumber: "Enter flight number",
    enterCargo: "Enter cargo",
    selectTransitAirport: "Select transit airport {index}",
    enterSttBaggingOrScan: "Enter STT/bagging no. or scan barcode",
    scanSttBaggingExample:
      "Example: STT/Bagging no.: 99LP1234567890123/88-22-12345678"
  },
  filters: {
    filter: "Filter",
    selectDate: "Select date",
    createCargoList: "Create cargo list",
    downloadFailedList: "Download failed list",
    cargoTypes: {
      plane: "Plane",
      truck: "Truck",
      train: "Train",
      ship: "Ship"
    }
  },
  messages: {
    noData: "Oops.. No data available yet",
    sttPaidTitle: "Make Sure the STT Number Is Paid",
    sttPaidMessage:
      "Check adjusted or overweight STT numbers again and make sure they are fully paid",
    confirmCancelTitle: "Are you sure you want to cancel?",
    confirmCancelMessage:
      'If you choose "Yes", the system will cancel the booking process',
    confirmDeleteTitle: "Are you sure you want to delete?",
    confirmDeleteMessage:
      "Deleted data will disappear from the Canceled/Failed list",
    confirmRebookTitle: "Confirm Cargo Rebooking?",
    confirmRebookMessage:
      "Please make sure all STT details are correct and complete",
    deleteBookingTitle: "Delete booking number?",
    deleteBookingMessage:
      '<b>Booking Number "{bookingNumber}"</b> will be removed from the cargo table.',
    rebookBookingTitle: "Book again?",
    rebookBookingMessage:
      'Are you sure you want to rebook <b>Booking No. "{bookingNumber}"</b>?',
    leavePageTitle: "Are you sure you want to leave?",
    leavePageMessage:
      "Please note that you will lose all data if you leave this page.",
    flightScheduleNotFinishedLeave:
      "The flight schedule list has not finished loading if you leave now.",
    maxPlanePiecesTitle: "Maximum plane pieces is 15 pieces",
    maxPlanePiecesMessage:
      "Please change the number of pieces in the cargo or choose another cargo transport",
    manualBookingWarning:
      "If you choose manual booking, you must book it first in the nGen system.",
    fillBookingData: "Complete booking data",
    fillFormData: "Complete the following data",
    selectPlaneSchedule: "Choose plane schedule",
    destinationAirportHeading: "Destination Airport",
    continueBookingCargo: "Continue Cargo Booking",
    checkAvailability: "Check availability",
    unsupportedDg: "This airline cannot send DG items.",
    fastestArrivalEta: "Fastest arrival (ETA)",
    onTimeDeparture: "On-time departure",
    processing: "Processing",
    pleaseTryAgain: "Please try again",
    unavailable: "Unavailable",
    available: "Available",
    dataNotFound: "Data not found",
    searchDataNotFound: "Sorry, the data you are looking for was not found.",
    readyToCargoClientFilterNoData:
      "There is no ready-to-cargo list that matches this client filter.",
    checkOrChangeFilter: "Check again or change your filter.",
    downloadFailed: "Download Failed!",
    cutOffSchedulePassed:
      "Cargo cut-off time has passed. Please choose the departure schedule again",
    searchDeadlineExceededMax:
      "Search deadline exceeds the maximum limit of {minutes} minutes.",
    dataUpdatedCheckAgain: "There is updated data, please check again",
    sttBagCannotUpdateTitle:
      "There are STT/Bag items that cannot be updated to Cargo.",
    sttBagCannotUpdateMessage:
      "There are STT/bag items that cannot be processed as cargo. Please check again.",
    serverConnectionFailed: "Failed to connect to the server",
    cutOffCyclePassed: "The cut-off time cycle has passed.",
    cutOffNear: "The cycle is close to cut-off time, book now!",
    weightExceededLimit: "Weight exceeds the limit",
    piecesExceededLimit: "Pieces exceed the limit",
    volumeExceededLimit: "Volume weight exceeds the limit",
    totalPiecesMaxLimit:
      "Total pieces exceed the maximum limit of {max} pieces.",
    totalGrossWeightMaxLimit:
      "Total weight exceeds the maximum limit of {max} kg.",
    totalVolumeWeightMaxLimit:
      "Total volume weight exceeds the maximum limit of {max} kg.",
    cargoWeightExceedsReweigh: "Cargo weight exceeds the reweigh weight",
    dataChanged: "Data changed",
    planeVolumeDividerInfo:
      "Plane cargo volume weight will be divided by {divider} from the dimensions.",
    editDimensionIfChanged: "Edit if the dimension changes",
    calculating: "Calculating",
    totalActualGrossWeightRequired: "Actual cargo gross weight is required",
    totalActualVolumeWeightRequired: "Actual cargo volume weight is required",
    totalActualPiecesRequired: "Actual total pieces is required",
    actualDimensionRequired: "Dimension is required",
    totalSttChangedAdjustDimension:
      "Total STT changed, please adjust the piece dimensions",
    pieceValueGreaterThanTotal:
      "Piece value is greater than total pieces. Please update and save with the same value",
    pieceValueLessThanTotal:
      "Piece value is less than total pieces. Please update and save with the same value",
    pieceDetailRequired:
      "Total Pieces, Piece Value, Dimension, and Volume Weight are required",
    pieceDimensionSavedTitle: "Piece Dimension Saved",
    pieceDimensionSavedMessage:
      "Piece dimension details have been saved successfully",
    confirmProcessPlaneCargoTitle: "Process this plane cargo?",
    confirmFlightDetailMessage:
      "Please make sure all flight details are correct and complete.",
    bookingInProcess: "Cargo Booking Is Being Processed",
    bookingRequestInProcess:
      "Cargo Booking {bookingRequestId} <br/> Is Being Processed",
    bookingSuccessNotification:
      "You will get a notification if the cargo booking succeeds",
    ngenProcessFailedTitle: "Cargo Booking Failed to Process in nGen",
    ngenProcessFailedMessage:
      "See the reason on the failed booking page. Check and book again",
    reschedulePlaneCargo: "You can still reschedule the plane cargo.",
    cargoNotFoundTitle: "Cargo Number Not Found",
    cargoNotFoundMessage:
      "Please check your cargo number again or book cargo manually",
    airportMismatchTitle: "Origin and destination airports do not match",
    airportMismatchMessage:
      "Please make sure the cargo number is correct. Any error in the cargo number will be the responsibility of the related consolidator",
    proofPhotoChangeWeight: "Weight change proof photo",
    uploadProofPhotoChangeWeight: "Upload proof photo to change weight",
    volumeDividerInfo:
      "Total volume weight is divided by 6,000 from the dimension, but if you choose plane cargo it will be divided by 5,000 from the dimension.",
    minimumWeightRecommendation:
      "Package weight is still below 10kg. It is recommended to add STT that will be sent as cargo",
    labelFooterSupport:
      "If there is a shipping issue, contact Customer Service at 021-80820072 or contact the related origin city.",
    noCargoItems: "There are no STT or bagging items in this cargo",
    totalDisputeBagging: "Total bags with weight discrepancy",
    invalidSttBaggingCargo: "STT/bagging number cannot be booked for cargo",
    cargoCommodityMismatch: "Cargo commodity does not match",
    noSttBaggingFoundOrDeleted:
      "STT/Bag number was not found or has already been removed",
    sttAlreadyInput: "STT number has already been entered",
    waitCustomerPay:
      "Wait until the customer has fully paid the outstanding charge",
    cannotUpdateToCargo:
      "Excess weight occurred, so the status cannot be updated to Cargo.",
    createSuccessTitle: "Created Successfully!",
    createFailedTitle: "Creation Failed!",
    createFailedMessage: "Cargo shipment failed to create.",
    editFailedTitle: "Update Failed!",
    editFailedMessage: "Cargo shipment failed to update.",
    canceledFailedStatus: "Canceled / Failed Booking",
    bookingManual: "Manual booking",
    bookingAuto: "Auto booking",
    recommended: "Recommended",
    failedStatus: "Failed",
    canceledStatus: "Canceled",
    inProgressStatus: "Booking In Progress",
    scheduleUnavailable:
      "Sorry, the plane cargo departure schedule is full or unavailable.",
    cargoDisputeTooltip: "Cargo with weight discrepancy",
    getDisputeSummaryFailed: "Failed to get cargo dispute summary!",
    downloadDisputeSummaryFailed: "Failed to download dispute summary data!",
    downloadMinimumWeightFailed: "Failed to download minimum weight data!",
    deleteStoragePhotoFailed: "Failed to delete photo from storage!",
    confirmCreateMessage:
      "Please make sure all STT details are correct and complete.",
    proofPhotoChangeWeightAlt: "Piece {index} weight change proof photo"
  },
  analytics: {
    inputSttSuccess: "STT input succeeded",
    inputSttFailed: "STT input failed",
    deleteSttSuccess: "STT was deleted successfully",
    bookingCargoSuccess: "Cargo was created successfully",
    bookingCargoFailed: "Cargo creation failed"
  },
  widget: {
    title: "Cargo download list",
    reportTitlePrefix: "Cargo List",
    generating: "Generate.xlsx",
    noDataFound: "No data found",
    failed: "Failed",
    download: "Download",
    printPdf: "Print PDF",
    outgoingCargoList: "Outgoing Cargo List"
  },
  units: {
    minute: "Minute",
    hour: "Hour",
    kg: "Kg",
    cm: "cm"
  },
  summary: {
    show: "Show",
    hide: "Hide",
    sttWeightTitle: "Weight Summary (STT)",
    reweighWeightTitle: "Weight Summary (Reweigh)"
  },
  uploadPhoto: {
    requiredRule:
      "Proof photos are required if the difference between cargo weight and reweigh weight reaches 1 kg or more",
    guideTitle: "Photo guide:",
    goodResolution: "Photo has good resolution.",
    readableScale: "Actual weight on the scale must be clearly readable.",
    visiblePackages: "All weighed packages must be clearly visible.",
    minimumOnePhoto: "Minimum 1 photo",
    scaleWithItem: "Scale photo <br /> with item",
    measurementWithItem: "Measurement photo <br /> with item",
    additionalPhoto: "Additional photo"
  },
  dispute: {
    withWeightDifference: "with weight discrepancy",
    dataRange: "Data {dateRange}",
    other: "Others",
    processedInBagging: "Processed in bagging",
    processedInCargo: "Processed in cargo"
  },
  pdf: {
    manifest: {
      title: "Cargo Manifest",
      operationsSupervisor: "Operations Supervisor",
      headers: {
        no: "No.",
        noBag: "Bag No.",
        noStt: "STT No.",
        totalPieces: "Total\nPieces",
        grossWeight: "Gross\nWeight",
        volumeWeight: "Volume\nWeight",
        product: "Product",
        commodity: "Commodity",
        originShort: "Origin",
        destinationShort: "Dest.",
        bagNo: "Bag no.",
        bagDestination: "Bag destination city",
        totalStt: "Total STT",
        totalPiecesCargo: "Total pieces",
        grossWeightCargo: "Cargo gross weight",
        volumeWeightCargo: "Cargo volume weight",
        chargeableWeight: "Cargo chargeable weight",
        originConsoleCity: "Console origin city",
        createdBy: "Created by",
        createdAt: "Created at",
        updatedBy: "Updated by",
        updatedAt: "Updated at"
      },
      table: {
        bagNo: "Bag no.",
        sttNo: "STT no.",
        grossWeight: "Gross Weight",
        totalPieces: "Total pieces",
        volumeWeight: "Volume weight",
        productType: "Product type",
        commodityName: "Commodity",
        originCityId: "Origin city",
        destinationCityId: "Destination city"
      },
      signature: {
        courier: "Courier"
      }
    },
    sptjElectronic: {
      title: "LITHIUM ION BATTERY CARRIAGE DECLARATION LETTER",
      intro:
        "In connection with the cargo agency cooperation with PT. Lion Mentari, I hereby act on behalf of our company:",
      name: "Name",
      position: "Position",
      companyName: "Company Name",
      defaultPosition: "Operations",
      defaultCompanyName: "Lion Parcel",
      shipmentHeader:
        "We will ship Electronic Goods using Lion Air flights, with the following details:",
      smuAwbNo: "SMU/AWB No",
      flightNo: "Flight No",
      flightRoute: "Flight Route",
      electronicGoodsType: "Electronic Goods Type",
      statementsTitle: "By this letter, we state:",
      point1:
        "We fully comply with the applicable rules and provisions regarding the shipment of goods/cargo (Electronic Goods) determined by PT. Lion Mentari.",
      point2:
        "The Lithium Ion Battery transport documents and packaging standards are in accordance with the applicable rules and provisions.",
      point3: "Capacity limits:",
      point3Sub1:
        "Lithium ION Cell <= 20 Wh equivalent to a maximum battery capacity of 5,000 mAh",
      point3Sub2:
        "Lithium Battery <= 100 Wh equivalent to a maximum battery capacity of 9,000 mAh",
      point4:
        "If there is any loss, damage, incident, or accident involving the contents and/or packaging of the cargo shipment, it is entirely our responsibility.",
      point5:
        "All compensation for loss, damage, or delays to any shipment, whether owned by us, our sub-agents, or other parties using our Airwaybill (SMU/AWB), is entirely our responsibility.",
      point6:
        "This letter is made truthfully, and a copy of this letter may be used as appropriate.",
      closing: "This declaration letter is made truthfully.",
      acknowledgedBy: "Acknowledged by:",
      createdBy: "Prepared by:",
      airlinesOfficer: "Airlines Officer",
      sender: "Sender",
      nameAndId: "Name & ID No.",
      clearName: "Full name",
      noteFile: "Note: This letter file is stored at the origin station",
      noteStrike: "(*) Cross out one option only",
      documentTitle: "Electronic_SPTJ_{smuNo}.pdf"
    },
    sptjNonElectronic: {
      title: "DECLARATION LETTER",
      subtitle: "RELEASE OF LIABILITY FOR CARGO TRANSPORTATION",
      intro: "I, the undersigned:",
      name: "Name",
      age: "Age",
      address: "Address",
      phone: "Phone/Mobile No.",
      shipmentDescription:
        "Will carry out cargo shipment using Lion Air / Batik Air / Wings Air / Super Air Jet flights.",
      receiverName: "Receiver Name",
      cargoContents: "Cargo Contents",
      totalPiecesWeight: "Total Pieces/kg",
      shipmentOrigin: "Shipment Origin",
      goodsCondition: "Goods Condition",
      goodsConditionDefault: "GOOD & BOXED",
      awbNo: "AWB/SMU No.",
      statementTitle: "DECLARES THAT",
      statement1:
        "I hereby declare that PT. Lion Express is released from all liability for any adverse consequences arising from the transportation of our goods/cargo mentioned above.",
      statement2:
        "In relation to this transportation, we have agreed to the following:",
      statement21:
        "To release the carrier from any liability for any losses caused by delays in transportation, including delayed arrival and delayed delivery of the goods.",
      statement22:
        "To release the carrier from liability for partial or total loss and/or arrival of fragile and/or damaged goods mentioned above.",
      statement3:
        "All costs arising, directly or indirectly, during transportation from the place of origin to the destination are our responsibility.",
      statement4:
        "Lion Air/Wings Air, including cargo agents and their employees, are released from any claims for losses or costs arising from damage to our goods/cargo.",
      closing: "This declaration letter is made truthfully.",
      airlinesOfficer: "Airlines Officer",
      relatedParty: "Concerned Party",
      relatedPartyName: "Concerned party name",
      note:
        "NB: 1 copy for the origin STO file & 1 copy for the destination STO",
      noteCheckPhysical: "-PHYSICAL CHECK AND PACKING",
      documentTitle:
        "CARGO TRANSPORT LIABILITY RELEASE LETTER LION PARCEL {originCityCode} - {cargoNumber}"
    },
    pti: {
      title: "CONTENT NOTIFICATION (PTI) LION PARCEL {originCityCode}",
      signerIntro: "The undersigned below:",
      senderName: "Sender name",
      address: "Address",
      phoneNumber: "Phone Number",
      identity: "ID / Other identity",
      identityDefault: "LION GROUP",
      description:
        "Explains that the shipment handed over to be transported by {airline} is addressed to:",
      receiverName: "Receiver name",
      airwayBillNo: "With AIR WAYBILL No.",
      goodsListTitle: "Contains the following goods:",
      totalPiecesHeader: "TOTAL PIECES",
      unitHeader: "UNIT",
      goodsContentHeader: "GOODS CONTENT",
      weightKgHeader: "WEIGHT KG.",
      pieceUnit: "PIECES",
      totalWeight: "TOTAL WEIGHT:",
      declaration:
        "After that, the sender states and acknowledges that filling in the content notification incorrectly may be subject to fines and/or confiscation of the shipment. The sender also declares willingness to pay compensation at any time for any losses caused by incorrect content notification details.",
      signAndName: "(Signature & Sender Full Name)",
      documentTitle:
        "CONTENT NOTIFICATION (PTI) LION PARCEL {originCityCode} - {cargoNumber}"
    }
  },
  stepper: {
    addStt: "Add STT",
    findCargo: "Find Cargo",
    processCargo: "Process Cargo",
    backToPreviousStepTitle: "Go back to the previous page?",
    backToPreviousStepMessage:
      "You will repeat the previous process if you go back"
  },
  gamification: {
    warning:
      "Before continuing the booking, you must enter the approval first. You only need to follow the provided text",
    instruction: "Type the Sentence as Instructed",
    errorMessage:
      "Type the sentence with the exact words, spaces, punctuation, and uppercase/lowercase letters shown in the box"
  },
  planeSchedule: {
    airportFilter: "Airport {count}",
    transitFilter: "Transit {count}",
    transitCount: "{count} Transit",
    transitTwoOrMore: ">= 2 transit",
    sort: "Sort",
    searchDeadline: "Search deadline",
    direct: "Direct",
    earliestArrival: "Earliest arrival",
    earliestDeparture: "Earliest departure",
    shortestLeg: "Shortest leg",
    loadingTitle: "Plane schedule list is loading",
    internetTitle: "Internet connection lost",
    serverTitle: "A system issue occurred",
    emptyTitle: "Plane cargo departure schedule is unavailable",
    loadingMessage: "We are looking for the best schedule for you.",
    internetMessage: 'Check your internal network and click "Reload".',
    serverMessage: 'Click "Reload" or try again later.',
    emptyMessage: "Change and recheck your plane schedule search.",
    showingAllToDestinationCity:
      "Showing all plane cargo options to your destination city.",
    showingAllToDestinationAirport:
      "Showing all plane cargo options to your destination airport.",
    showingAllToTransitAirport:
      "Showing all plane cargo options to transit airport {index}"
  },
  readyToCargo: {
    tabProcessTitle: "Ready to Cargo In Progress",
    tabReadyListTitle: "Ready to Cargo List",
    searchPlaceholderProcess: "Search Bagging / STT No.",
    filter: "Filter",
    tambah: "Add",
    statusDalamProses: "In Progress",
    statusGagalDiproses: "Failed",
    statusBerhasilDiproses: "Processed",
    colNoBaggingStt: "Bagging/STT No.",
    colDiperbaruiOleh: "Updated By",
    colKotaAsal: "Origin City",
    colKotaTujuan: "Destination City",
    status: "Status",
    deskripsi: "Description",
    searchPlaceholderReady: "Search Ready to Cargo No.",
    pilihStatus: "Select Status",
    harusDikargo: "Must Cargo",
    bisaDikargo: "Can Cargo",
    no: "No.",
    noSiapKargo: "Ready to Cargo No.",
    totalKoli: "Total Pieces",
    totalBagging: "Total Bagging",
    tipeKargo: "Cargo Type",
    proses: "Process",
    modalProcessTitle: "Do you want to process {no}?",
    modalProcessMessage:
      "Make sure all bagging has been collected in the same place",
    kembali: "Back",
    tooltipStatusMin:
      "Minimum bagging weight has not been reached and can be processed for cargo",
    tooltipStatusMax:
      "Maximum bagging weight has been reached and must be processed for cargo",
    tambahData: "Add Data",
    noSttNoBagging: "STT No./Bagging No.",
    labelStackedExample:
      "Example: STT No./Bagging No.: 99LP1234567890123/88-22-12345678",
    placeholderInput: "Enter STT No./Bagging No. or scan barcode",
    hapus: "Delete",
    modalSuccessTitle: "Bagging and STT Will Be Processed to RTC",
    modalSuccessMessage:
      "Please check your bagging and STT during the cargo booking process",
    modalPartialTitle: "Some data failed to be added.",
    modalPartialMessage:
      "Some STT/Bagging items failed to be added to Ready to Cargo. Please download the file to review the details.",
    modalFailedTitle: "Add Data Failed",
    modalFailedMessage:
      "Failed to add Bagging and STT data. Please download the file to review the details.",
    download: "Download",
    sttBerhasilDihapus: "STT deleted successfully",
    modalDeleteMessage: "You can add a new STT to the shipment list",
    hapusStt: "Delete STT",
    batalkan: "Cancel",
    wordingDeleteStt:
      "The STT you delete will be removed from the shipment list",
    wordingDeleteBag:
      "All STTs from the same bag number will be removed from the shipment list",
    noBag: "Bag No.",
    noStt: "STT No.",
    noReferensi: "Reference No.",
    beratKotor: "Gross Weight",
    beratDimensi: "Volume Weight",
    produk: "Product",
    komoditas: "Commodity",
    action: "Action",
    ok: "OK",
    errorAdjustmentNotApproved:
      "STT adjustment has not been approved by the Lion Parcel team. Please wait for customer service follow-up.",
    errorScanAdjustmentNotApproved:
      "Scan failed because the STT adjustment has not been approved by the Lion Parcel team. Please wait to be contacted by customer service.",
    titleSttNotRtc: "STT number cannot be processed to RTC",
    titleBaggingNotRtc: "Bagging number cannot be processed to RTC",
    waitCustomerPay:
      "Wait until the customer has fully paid the outstanding charge",
    sttUnderpaidInBag: "There is an underpaid STT",
    statusSttHasBeen: "This STT status has been {status}",
    statusBaggingNotMatch: "The STT status in the bagging does not match",
    errorSttAlreadyInput: "STT number has already been entered",
    scanFailedListTitle: "Failed STT/Bag scan list",
    excelHeaderSttBag: "STT/Bag Number",
    excelHeaderLastStatus: "Latest STT/Bag Status",
    excelHeaderFailureReason: "Failure Reason",
    excelHeaderDemNo: "DEM Number",
    excelHeaderSttNo: "STT Number",
    excelHeaderLastStatusDispatch: "Latest STT Status",
    sheetNameScanFailed: "Failed STT scan",
    fileNameScanFailed: "failed-stt-scan.xlsx"
  },
  v2: {
    daftar: {
      pageTitle: "Cargo List"
    },
    badge: {
      dangerousGoods: "Dangerous Goods",
      quarantine: "Quarantine",
      new: "New"
    },
    column: {
      transitCount: "{count} transit",
      viewMorePrintStatus: "View more",
      printStatus: "Print status",
      etd: "ETD",
      totalPiecesGrossWeightShort: "Total pieces/Gross w.",
      piecesGrossWeightValue: "{pieces} pcs / {weight} kg",
      reason: "Reason"
    },
    datetime: {
      timezoneSuffix: "{date} MYT"
    },
    print: {
      labelCargo: "Cargo label",
      awbLionCargo: "AWB Lion Cargo",
      pti: "PTI",
      sptj: "SPTJ",
      manifestCargo: "Cargo manifest"
    },
    actions: {
      printLabel: "Print cargo label",
      printManifest: "Print cargo manifest",
      printAwb: "Print AWB Lion Cargo",
      printPti: "Print PTI",
      printSptj: "Print SPTJ",
      printSptjElectronic: "Print SPTJ"
    },
    etd: {
      dayOffsetSingular: "+1 day",
      dayOffsetPlural: "+{count} days"
    },
    filter: {
      searchPlaceholder: "Cargo no./AWB",
      selectAll: "All",
      moda: "Mode",
      selectModa: "Select Mode"
    },
    empty: {
      reasonUnavailable: "Not available yet"
    },
    errors: {
      downloadFailedList: "Failed to download list!"
    },
    detail: {
      tooltip: {
        cargoWeightDispute: "Cargo with weight discrepancy",
        cargoNog:
          "Fill in NOG according to the commodity of goods in the cargo.",
        shcCode:
          "SHC will be automatically filled based on the selected cargo commodity."
      },
      badge: {
        quarantine: "Quarantine",
        inProgress: "Booking in progress",
        cancelledFailed: "Cancelled/Failed Booking"
      },
      action: {
        delete: "Delete",
        rebook: "Rebook",
        editBooking: "Edit booking",
        viewPhotoProof: "View {count} another photos"
      },
      modal: {
        delete: {
          title: "Delete booking number?"
        },
        rebook: {
          title: "Rebook?"
        }
      },
      tab: {
        info: "Detail information",
        history: "Cargo status history"
      },
      error: {
        fetchDetail: "Failed to fetch cargo detail"
      },
      print: {
        label: "Cargo label",
        manifest: "Cargo manifest"
      },
      field: {
        bookingDate: "Booking date",
        lastUpdated: "Last updated",
        commodity: "Commodity",
        product: "Product",
        sttWeight: "STT weight",
        cargoWeight: "Cargo weight"
      },
      section: {
        printLabel: "Cargo label",
        printManifest: "Cargo manifest",
        weightDispute: "Weight discrepancy",
        sttList: "STT list",
        bagList: "Bag list"
      },
      disputeStatus: {
        bagging: "Processed at bagging",
        cargo: "Processed at cargo"
      }
    },
    dispute: {
      photo: {
        viewProof: "View proof photo"
      }
    },
    history: {
      empty: {
        noData: "No data to display yet"
      },
      link: {
        deliveryProof: "View delivery proof",
        weightChangePhoto: "View weight change photo"
      },
      field: {
        coliCount: "Number of colis"
      },
      direct: "Direct",
      close: "Close",
      flightDetails: "Flight details"
    },
    flight: {
      search: {
        title: {
          selectSchedule: "Select schedule"
        },
        action: {
          reload: "Reload",
          apply: "Apply"
        },
        empty: {
          loadingTitle: "Loading flight schedule list",
          serverErrorTitle: "System error occurred",
          networkErrorTitle: "Internet connection lost",
          filterNotFoundTitle: "No results found",
          noScheduleTitle: "No flight schedule available",
          loadingMessage: "Searching for matching schedules.",
          serverErrorMessage: "Please try again shortly",
          networkErrorMessage: "Please check your internet connection",
          filterNotFoundMessage: "Check and reset your filters",
          noScheduleMessage: "Change date or filters to find other schedules"
        },
        header: {
          totalPieces: "Total pieces",
          grossVolumeWeight: "Gross w./ Volume w."
        },
        date: {
          selectOther: "Select another date"
        },
        filter: {
          selectAirport: "Select airport",
          originAirport: "Origin airport",
          destinationAirport: "Destination airport",
          transitCount: "Transit count",
          selectTransitCount: "Select transit count",
          sort: "Sort",
          selectSort: "Select sort order",
          thresholdTime: "Time threshold",
          selectThreshold: "Select time threshold",
          hours12: "12 hours from now",
          hours24: "24 hours from now",
          airportRoute: "Airport: {origin} - {destination}",
          airportOriginOnly: "Origin airport: {origin}",
          airportDestinationOnly: "Destination airport: {destination}",
          originLabel: "{list}",
          destinationLabel: "{list}",
          direct: "Direct",
          transit1: "1 transit",
          transit2: "2 transits",
          transit3: ">3 transits",
          fastestEta: "Fastest ETA",
          fastestEtd: "Fastest ETD"
        },
        card: {
          arrivalDayOffset: "+{count} days",
          volumeUnavailable: "Insufficient aircraft volume",
          dimensionUnavailable: "Aircraft dimension insufficient",
          capacityUnavailable: "Aircraft capacity insufficient",
          embargo: "Embargo route",
          capacityAvailable: "Capacity available",
          dgNotAllowed: "Cannot ship DG items",
          potentialDelay: "Potential delay",
          onTime: "On-time",
          departsIn: "Departs in",
          duration: "{hours} hr {mins} min",
          viewTransitDetail: "View transit detail",
          closeTransit: "Close",
          booking: "Book",
          transitCapacity: "Capacity • {kg} kg",
          direct: "Direct",
          transitLabel: "{count} transit",
          durationZero: "0 min",
          durationMinutes: "{mins} min",
          durationHours: "{hours} hr",
          durationHoursMinutes: "{hours} hr {mins} min"
        },
        modal: {
          delay: {
            title: "Confirm delayed schedule",
            route: "Route",
            departure: "Departure",
            arrival: "Arrival",
            changeSchedule: "Change schedule",
            confirmBooking: "Yes, Book"
          }
        }
      }
    },
    nog: {
      error: {
        required: "NOG field is required."
      }
    }
  },
  pickup: {
    confirmTitleCreate: "Create Pick Up Manifest?",
    confirmTextSuccess: "Create",
    cancel: {
      button: "Cancel",
      confirm: {
        title: "Are you sure you want to cancel the shipment?",
        instruction: "Enter the cancellation reason before proceeding.",
        reasonPlaceholder: "Cancellation reason",
        back: "Cancel",
        continue: "Continue",
        charCounter: "{current}/{max}"
      },
      success: {
        title: "Shipment successfully cancelled",
        body: "The shipment cancellation has been successfully processed.",
        close: "Close"
      },
      failed: {
        title: 'Failed to cancel "{shipmentId}"',
        body: "Pick up cancellation failed. Please check and try again.",
        back: "Back",
        retry: "Retry"
      },
      sidebar: {
        reasonLabel: "Cancellation reason"
      }
    },
    bookingSummary: {
      titleSuggestion: "Recommended to pick up",
      titleBucket: "Ready to pick up",
      changeAddress: "Change address",
      requestPickup: "Request Pick Up",
      nearestSchedule: "Nearest schedule:",
      viewStt: "View STT",
      viewActivePickup: "View active Pick Up {count}",
      empty:
        "Pickup request data is unavailable. Please create the pickup manually",
      createManual: "Create Pick Up Manually",
      piece: "pcs",
      wood: "WOOD",
      addressIsEmpty: "No pick-up address has been added.",
      addAddress: "Add address"
    },
    scheduleConfig: {
      pageTitle: "Set Pick Up schedule",
      breadcrumb: {
        parent: "Pick Up Schedule Configuration"
      },
      sidebar: {
        addressTitle: "Pick Up Address",
        changeAddress: "Change address",
        saveSchedule: "Save schedule",
        defaultBadge: "Primary",
        coordinatesLabel: "Coordinate point:",
        empty: "No saved address yet"
      },
      shipment: {
        sectionTitle: "Shipment Information",
        estimateAdditionalKoli: "Estimated additional pieces",
        estimateWeight: "Estimated weight",
        weightSuffix: "kg",
        serviceType: "Shipping service",
        placeholderKoli: "Enter estimated additional pieces",
        placeholderWeight: "Enter estimated weight",
        placeholderService: "Select shipping service"
      },
      scheduleSectionTitle: "Pick Up Schedule",
      regular: {
        title: "Regular schedule",
        tooltip:
          "The latest Pick Up schedule will be applied starting tomorrow.",
        maxSlotsNote: "(Max. 3 schedules per day.)",
        addTime: "Add time",
        emptySlots: "No time selected",
        popoverTitle: "Select Pick Up time",
        durationFooter: "Duration 1 hour",
        duplicateTime: "This time has already been added",
        confirmTime: "Select",
        emptyTimeOptions: "No time options available",
        days: {
          monday: "Monday",
          tuesday: "Tuesday",
          wednesday: "Wednesday",
          thursday: "Thursday",
          friday: "Friday",
          saturday: "Saturday",
          sunday: "Sunday"
        }
      },
      special: {
        modalTitle: "Select Pick-up schedule",
        pickDateLabel: "Select date",
        pickTimeLabel: "Select time",
        save: "Save",
        duplicateDate: "This date has already been added",
        modalMaxSlotsNote: "Max. 3 schedules per day.",
        title: "Special schedule",
        tooltipTitle: "Special Schedule",
        tooltipDescription:
          "Special schedules will override regular schedules on the selected dates.",
        maxDatesNote: "(Max. 3 dates.)",
        addDate: "Select Pick-up date",
        reset: "Reset",
        addTime: "Add time"
      }
    }
  },
  pickupV2: {
    list: {
      title: "Pickup List",
      createConfig: "Set Pickup Schedule",
      wood: "WOOD",
      piece: "pcs",
      table: {
        orderId: "Order ID",
        status: "Status",
        totalRequest: "Total requested",
        totalRequestTooltip: "Total number of pieces requested for pickup.",
        totalPickup: "Total picked up",
        totalPickupTooltip:
          "Total number of shipments and pieces that have been picked up by the courier.",
        agentHubProcessed: "Processed by Agent/Hub",
        agentHubProcessedTooltip:
          "Total number of shipments and pieces processed by the Agent/Hub.",
        createdAt: "Created at"
      },
      emptyTitle: "No Pickup List Available",
      emptyMessage: "All pickup requests will appear on this page.",
      notFoundTitle: "No Results Found",
      notFoundMessage:
        "Please check your keywords or try using different keywords.",
      summary: {
        pickUp: "Pick Up",
        waitingCourier: "Waiting for Courier",
        pickUpPackage: "Pick Up Package",
        mergedPickUp: "Merged Pick Up",
        pickUpCompleted: "Pick Up Completed",
        processedAgentHub: "Processed by Agent/Hub"
      },
      filter: {
        searchPlaceholder: "Search Order ID",
        pickupSchedule: "Pickup Schedule",
        vehicleType: "Vehicle Type",
        vehicleTypePlaceholder: "Select vehicle type",
        serviceType: "Service Type",
        status: "Status",
        statusPlaceholder: "Select status",
        statusList: {
          searchingCourier: "Searching for Courier",
          courierAssigned: "Courier Assigned",
          packagePickedUp: "Package Picked Up",
          completed: "Completed",
          cancelledByCourier: "Cancelled by Courier",
          cancelledByClient: "Cancelled by Client",
          cancelledByAdmin: "Cancelled by Admin"
        }
      }
    },
    modalSttPickupList: {
      title: "List of STTs Available for Pickup ({bkdCount})",
      searchPlaceholder: "Search STT",
      totalCount: "{count} STTs",
      empty: {
        title: "No STTs Available for Pickup",
        message: "There are no STTs to display."
      },
      notFound: {
        title: "No Results Found",
        message: "Check your keyword or try a different search term."
      },
      copyStt: "Copy STT Number",
      copiedStt: "STT number copied to clipboard",
      column: {
        sttNo: "STT No.",
        shipmentNo: "Shipment No.",
        lastStatus: "Latest Status",
        destinationCity: "Destination City",
        productType: "Shipping Service",
        chargeableWeight: "Chargeable Weight",
        createdAt: "Booking Date",
        bookedFor: "Booked For"
      }
    }
  }
};
